module.exports = __webpack_public_path__ + "img/Image_13.b10a2e61.png";